module.exports = __webpack_public_path__ + "static/media/case1C.1313432.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case1C.mp4
// module id = FFNl
// module chunks = 0